/**
 * Shared Clerk session check — single source of truth.
 * Previously duplicated in skills-managed.ts, integrations.ts, and public-storefront.ts.
 */
import { getClerkSync } from "./clerk-auth.ts";

export function hasClerkSession(): boolean {
  return !!(getClerkSync()?.session);
}
